import { ArrowRight, ArrowUpRight } from "lucide-react";

function categoryCopy(name) {
  const value=String(name||"").toLowerCase();
  if(value.includes("fabric")) return "Browse fabrics by colour, pattern and unit, compare prices, choose your quantity and arrange doorstep delivery.";
  if(value.includes("material")) return "Shop tailoring tools, trims, buttons, zippers, threads and supplies for personal or professional sewing projects.";
  if(value.includes("dry")||value.includes("press")) return "Book professional cleaning, stain care and pressing for everyday, delicate and occasion garments.";
  if(value.includes("machine")) return "Arrange machine repair, maintenance, cleaning, oiling or installation with a trained professional.";
  if(value.includes("alteration")) return "Improve fit, repair damage and update existing garments with convenient collection and delivery.";
  if(value.includes("measurement")) return "Schedule accurate measurements at home and save them for future orders.";
  if(value.includes("stitch")) return "Choose Women, Men, Kids, Home Furnishing or Uniforms, then personalise design, measurements, fabric and finishing.";
  return "Choose what you need, personalise the details and continue through a guided StichB experience.";
}

export default function CategoryServiceCard({
  category,
  sections = [],
  index = 0,
  onCategoryClick,
  onSectionClick,
}) {
  const safeSections = Array.isArray(sections) ? sections : [];
  const isFeatured = index === 0;
  const visibleSections = safeSections.slice(0, isFeatured ? 6 : 4);

  return (
    <article
      role="link"
      tabIndex={0}
      onClick={() => onCategoryClick?.(category)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onCategoryClick?.(category);
        }
      }}
      className={`lift card-soft text-left overflow-hidden group cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#F46524] ${
        isFeatured ? "xl:col-span-2" : ""
      }`}
    >
      <div
        className={`home-category-image overflow-hidden bg-[#FFF3E8] ${
          "aspect-[16/9]"
        }`}
      >
        {category.image ? (
          <img
            src={category.image}
            alt={category.name}
            loading="lazy"
            className="w-full h-full object-contain object-center transition-opacity duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#F46524] font-semibold">
            StichB
          </div>
        )}
      </div>

      <div className="p-4 sm:p-5">
        <div className="flex items-start justify-between gap-4 mb-2">
          <h3 className="font-display text-xl md:text-2xl leading-tight">
            {category.name}
          </h3>

          <span className="w-10 h-10 rounded-full bg-[#FFEDDD] flex items-center justify-center text-[#F46524] group-hover:bg-[#F46524] group-hover:text-white transition-colors shrink-0">
            <ArrowUpRight size={18} />
          </span>
        </div>

        <p className={`text-[#5b5a56] text-xs leading-relaxed mb-3 ${String(category.name||"").toLowerCase().includes("fabric")?"":"line-clamp-3"}`}>{category.description || categoryCopy(category.name)}</p>

        {visibleSections.length > 0 ? (
          <div
            className={`grid ${
              isFeatured
                ? "grid-cols-3 sm:grid-cols-6"
                : "grid-cols-2 sm:grid-cols-4"
            } gap-1.5 mb-3`}
          >
            {visibleSections.map((section) => {
              const image = section.image || section.imageUrl || "";

              return (
                <button type="button" onClick={(event) => { event.stopPropagation(); onSectionClick?.(category, section); }} onKeyDown={(event) => event.stopPropagation()} key={section.id} className="min-w-0 text-left rounded-xl hover:ring-2 hover:ring-[#F46524] focus:outline-none focus:ring-2 focus:ring-[#F46524]">
                  <div className="home-section-image aspect-square rounded-lg overflow-hidden bg-[#FFF3E8]">
                    {image ? (
                      <img
                        src={image}
                        alt={section.name}
                        loading="lazy"
                        className="w-full h-full object-contain object-center"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center p-2 text-center text-[10px] text-[#8a8781]">
                        {section.name}
                      </div>
                    )}
                  </div>

                  <div className="mt-2 text-[11px] font-semibold truncate">
                    {section.name}
                  </div>
                </button>
              );
            })}
          </div>
        ) : null}

        {String(category.name||"").toLowerCase().includes("fabric")?<div className="flex flex-wrap gap-1.5 mb-4 text-[10px] font-semibold text-[#8D401C]"><span className="bg-[#FFF1E9] rounded-full px-2.5 py-1">Colours & patterns</span><span className="bg-[#FFF1E9] rounded-full px-2.5 py-1">Flexible quantities</span><span className="bg-[#FFF1E9] rounded-full px-2.5 py-1">Home delivery</span></div>:null}
        <button type="button" onClick={(event) => { event.stopPropagation(); onCategoryClick?.(category); }} onKeyDown={(event) => event.stopPropagation()} className="text-sm font-semibold text-[#F46524] inline-flex items-center gap-2">
          {category.name?.toLowerCase().includes("fabric") || category.name?.toLowerCase().includes("material") ? "Explore catalogue" : category.name?.toLowerCase().includes("dry") ? "Explore services" : safeSections.length > 0 ? `Explore all ${safeSections.length} sections` : "Explore services"}
          <ArrowRight size={14} />
        </button>
      </div>
    </article>
  );
}

